import { atom } from "recoil";

export const clientsTokenStore = atom<string>({
  key: "clientsTokenStoreData",
  default: "",
});
